export default __webpack_public_path__ + "static/media/entreo_dashboard.b1ff5a52.svg";